  import api from './api';

  export const authService = {
    // Registro

    register: async (userData) => {
      const response = await api.post('/auth/register', userData);
      return response.data;
    },

    // Login

    login: async (credentials) => {
      const response = await api.post('/auth/login', credentials);
      if (response.data.access_token) {
        localStorage.setItem('auth_token', response.data.access_token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
      }
      return response.data;
    },

    // Logout

    logout: async () => {
      const response = await api.post('/auth/logout');
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user');
      return response.data;
    },

    // Logout en todos los dispositivos

    logoutAll: async () => {
      const response = await api.post('/auth/logout-all');
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user');
      return response.data;
    },

    // Obtener usuario actual

    me: async () => {
      const response = await api.get('/auth/me');
      return response.data;
    },

    // Verificar si está autenticado
    isAuthenticated: () => {
      return !!localStorage.getItem('auth_token');
    },

    // Obtener usuario del localStorage
    getCurrentUser: () => {
      const user = localStorage.getItem('user');
      return user ? JSON.parse(user) : null;
    },

    // Obtener token
    getToken: () => {
      return localStorage.getItem('auth_token');
    },

    // Login con token SSO (desde CIP)
    loginWithToken: (token, userData) => {
      localStorage.setItem('auth_token', token);
      localStorage.setItem('user', JSON.stringify(userData));
      return { access_token: token, user: userData };
    }
  };
